import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useContext, useEffect } from 'react';
import EditTable from './EditTable';
import { UserContext } from '../userContext';
import { getProvince } from '../../api';
var columns = [{
  id: 'name',
  accessor: function accessor(i) {
    return i.name;
  }
}, {
  id: 'address',
  Cell: function Cell(_ref) {
    var i = _ref.original;
    return "".concat(i.line1 && "".concat(i.line1, ", "), " \n        ").concat(i.line2 ? "".concat(i.line2, ", ") : '', "\n        ").concat(i.city && "".concat(i.city, ", "), "\n        ").concat(i.province && i.province.name && "".concat(i.province.name, ", "), "\n        ").concat(i.zipOrPostcode && "".concat(i.zipOrPostcode, ", "), "\n        ").concat(i.country && i.country.countryName);
  }
}];

var Address = function Address(_ref2) {
  var countryList = _ref2.countryList,
      isCountryLoading = _ref2.isCountryLoading,
      prefix = _ref2.prefix,
      trans = _ref2.trans;
  var defaultFormItemList = [{
    visible: true,
    required: true,
    item: {
      type: 'text',
      name: 'name',
      label: trans('SFxUserPreferencesAddressNameLabel'),
      maxLength: 50
    }
  }, {
    visible: true,
    required: true,
    item: {
      type: 'text',
      name: 'line1',
      label: trans('SFxUserPreferencesAddressLabel'),
      maxLength: 50
    }
  }, {
    visible: true,
    required: false,
    item: {
      type: 'text',
      name: 'line2',
      label: trans('SFxUserPreferencesAddressLine2Label'),
      maxLength: 50
    }
  }, {
    visible: true,
    required: true,
    item: {
      type: 'select',
      name: 'country',
      label: trans('SFxUserPreferencesAddressCountryLabel'),
      relatedName: 'province',
      options: [],
      showFlag: true,
      renderOption: function renderOption(i) {
        return {
          label: i.countryName,
          value: i.geonameId
        };
      }
    }
  }, {
    visible: true,
    required: true,
    item: {
      type: 'select',
      name: 'province',
      label: trans('SFxUserPreferencesAddressStateLabel'),
      options: [],
      renderOption: function renderOption(i) {
        return {
          label: i.name,
          value: i.geonameId
        };
      }
    }
  }, {
    visible: true,
    required: true,
    item: {
      type: 'text',
      name: 'city',
      label: trans('SFxUserPreferencesAddressCityLabel'),
      maxLength: 100
    }
  }, {
    visible: true,
    required: true,
    item: {
      type: 'text',
      name: 'zipOrPostcode',
      label: trans('SFxUserPreferencesAddressZipCodeLabel'),
      maxLength: 100
    }
  }];

  var _useContext = useContext(UserContext),
      userData = _useContext.userData,
      updateUserData = _useContext.updateUserData;

  var _userData$profile$use = userData.profile.userAddresses,
      userAddresses = _userData$profile$use === void 0 ? [] : _userData$profile$use;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = useState(defaultFormItemList),
      _useState4 = _slicedToArray(_useState3, 2),
      formItemList = _useState4[0],
      setFormItemList = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      country = _useState6[0],
      setCountry = _useState6[1];

  useEffect(function () {
    if (userAddresses.length) {
      var tableDataAction = userAddresses.map(function (i) {
        return i.main ? _objectSpread(_objectSpread({}, i), {}, {
          readOnly: true
        }) : _objectSpread(_objectSpread({}, i), {}, {
          canDel: true,
          canEdit: true
        });
      });
      setTableData(tableDataAction);
    }
  }, [userAddresses]);

  var formItemListGenerate = function formItemListGenerate(name, newItem) {
    var newFormItemList = formItemList.map(function (i) {
      return i.item.name === name ? _objectSpread(_objectSpread({}, i), {}, {
        item: _objectSpread(_objectSpread({}, i.item), newItem)
      }) : i;
    });
    setFormItemList(newFormItemList); // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(function () {
    if (countryList.length) {
      formItemListGenerate('country', {
        options: countryList,
        isLoading: isCountryLoading
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [countryList, isCountryLoading]);

  var updateTableData = function updateTableData(userAddresses) {
    setTableData(userAddresses);

    var profile = _objectSpread(_objectSpread({}, userData.profile), {}, {
      userAddresses: userAddresses
    });

    updateUserData(_objectSpread(_objectSpread({}, userData), {}, {
      profile: profile
    }));
  };

  useEffect(function () {
    if (country && country.geonameId) {
      var getProvinceList = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(geonameId) {
          var _yield$getProvince, data;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  formItemListGenerate('province', {
                    options: [],
                    isLoading: true,
                    isProvinceDisabled: true
                  });
                  _context.prev = 1;
                  _context.next = 4;
                  return getProvince(geonameId);

                case 4:
                  _yield$getProvince = _context.sent;
                  data = _yield$getProvince.data;
                  formItemListGenerate('province', {
                    options: data,
                    isLoading: false,
                    isProvinceDisabled: false
                  });
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  formItemListGenerate('province', {
                    options: [],
                    isLoading: true,
                    isProvinceDisabled: true
                  });

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 9]]);
        }));

        return function getProvinceList(_x) {
          return _ref3.apply(this, arguments);
        };
      }();

      getProvinceList(country.geonameId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [country]);
  return /*#__PURE__*/React.createElement(EditTable, {
    prefix: prefix,
    addButtonText: trans('SFxUserPreferencesAddAddressText'),
    containerId: "addressTab",
    tableData: tableData,
    columns: columns,
    formItemList: formItemList,
    updateTableData: updateTableData,
    updateFormItemList: function updateFormItemList(_ref4) {
      var country = _ref4.country;
      setCountry(country);
    },
    trans: trans
  });
};

export default Address;